import { useState, type ReactNode } from 'react';
import { CButton, CCard, CCardBody, CCardHeader } from '@coreui/react';

/**
 * Karta detailu. Formulář je schovaný za „+ …" a otevře se, až když ho člověk chce —
 * čtyři trvale otevřené formuláře na jedné stránce byly to, co nováčky mátlo nejvíc.
 * Prázdná sekce bez otevřeného formuláře ukáže jen nadpis.
 */
export function Section({ title, count, addLabel, form, onAdd, children, empty, tour, extra }: {
  title: string;
  count?: number;
  addLabel?: string;
  form?: (close: () => void) => ReactNode;
  /** Místo formuláře rovnou akce — třeba výběr souboru. */
  onAdd?: () => void;
  children?: ReactNode;
  empty?: boolean;
  /** Značka pro průvodce na tlačítku „+ …“. */
  tour?: string;
  /** Další akce v hlavičce vedle „+ …“ — třeba „Vyfotit“ na mobilu. */
  extra?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-flex justify-content-between align-items-center">
        <strong>{title}{count ? <span className="text-body-secondary fw-normal"> ({count})</span> : null}</strong>
        <div className="d-flex gap-1">
          {extra}
          {(form || onAdd) && addLabel && !open && (
            <CButton size="sm" color="primary" variant="ghost" data-tour={tour} onClick={() => (onAdd ? onAdd() : setOpen(true))}>+ {addLabel}</CButton>
          )}
        </div>
      </CCardHeader>
      {(open || !empty) && (
        <CCardBody>
          {open && form && <div className={empty ? '' : 'mb-3 pb-3 border-bottom'}>{form(close)}</div>}
          {!empty && children}
        </CCardBody>
      )}
    </CCard>
  );
}
